import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_radio_button.scss'

import { InputAttributes, Props } from '../utils/types'

export interface RadioButtonProps extends Props {
  checked?: boolean
  disabled?: boolean
}

const cx = bind(styles)

const RadioButton = React.forwardRef<
  HTMLInputElement,
  InputAttributes & RadioButtonProps
>(({ children, className, style = {}, ...props }, ref) => (
  <label
    className={cx(
      'core-radio-button',
      { 'core-radio-button--empty-label': !children },
      className
    )}
    style={style}
  >
    <input
      className={cx('core-radio-button__input')}
      type="radio"
      ref={ref}
      {...props}
    />
    <p className={cx('core-radio-button__label')}>{children}</p>
  </label>
))

RadioButton.displayName = 'RadioButton'

export default RadioButton
